import React from "react";

import classes from "./Button.module.scss";

type Variant = "primary" | "secondary" | "ghost" | "danger";

type Props = {
  title: string;
  onClick?: () => void;
  type?: "button" | "submit";
  variant?: Variant;
  disabled?: boolean;
  loading?: boolean;
  fullWidth?: boolean;
};

const VARIANT_CLASS: Record<Variant, string> = {
  primary: classes.Primary,
  secondary: classes.Secondary,
  ghost: classes.Ghost,
  danger: classes.Danger,
};

export const Button: React.FC<Props> = ({
  title,
  onClick,
  type = "button",
  variant = "primary",
  disabled,
  loading,
  fullWidth,
}) => {
  return (
    <button
      className={`${classes.Container} ${VARIANT_CLASS[variant]} ${
        fullWidth ? classes.FullWidth : ""
      } ${loading ? classes.Loading : ""}`}
      onClick={onClick}
      disabled={disabled || loading}
      type={type}
    >
      {loading ? <span className={classes.Spinner} /> : title}
    </button>
  );
};
